// extracted by mini-css-extract-plugin
export var caption = "Map-module--caption--23fe7";
export var container = "Map-module--container--7096e default-module--container--edca7";
export var heading = "Map-module--heading--f8b5b index-module--c-heading-1--61ad7 default-module--font-bold--e6812";
export var iframeWrapper = "Map-module--iframe-wrapper--16ba5";
export var list = "Map-module--list--98012";
export var listItem = "Map-module--list-item--6b4c1";
export var small = "Map-module--small--1cd25";
export var smallHeading = "Map-module--small-heading--41ee1 default-module--font-bold--e6812";
export var textBlock = "Map-module--text-block--6f014";